// **************************************************
//
// IMPORT
//
// **************************************************
const THREE = require('three')
// import scene from '../scene'
import {types as tileTypes, tileSize, direction, layout} from './config'
import {config as gameConfig} from '../config'
let normalize = require('normalize-path-scale')

// **************************************************
//
// SCALE PATH
//
// **************************************************

// export let getPath = function (tileTypes, tileSize, direction, layout, gameConfig, scale) {
export let getPath = function (offset) {
  let path = new THREE.CurvePath()

  let nextPosition = [0, 0]
  let currDirection = direction.N

  for (let tileId of layout) {
    const tileType = tileTypes[tileId]

    let fromDirection = currDirection
    let fromPosition = [nextPosition[0], nextPosition[1]]

    // CALCULATE NEXT
    currDirection += tileType.directionChange + 360
    currDirection %= 360

    switch (currDirection) {
      case direction.N:
        nextPosition[1] -= tileSize
        break
      case direction.W:
        nextPosition[0] -= tileSize
        break
      case direction.S:
        nextPosition[1] += tileSize
        break
      case direction.E:
        nextPosition[0] += tileSize
        break
    }

    // START POINT
    let start = [fromPosition[0], fromPosition[1]]
    switch (fromDirection) {
      case direction.N:
        start[1] += tileSize / 2
        start[0] += offset
        break
      case direction.W:
        start[0] += tileSize / 2
        start[1] += offset
        break
      case direction.S:
        start[1] -= tileSize / 2
        start[0] -= offset
        break
      case direction.E:
        start[0] -= tileSize / 2
        start[1] -= offset
        break
    }

    // TO POINT
    let to = [fromPosition[0], fromPosition[1]]
    switch (currDirection) {
      case direction.N:
        to[1] -= tileSize / 2
        to[0] += offset
        break
      case direction.W:
        to[0] -= tileSize / 2
        to[1] += offset
        break
      case direction.S:
        to[1] += tileSize / 2
        to[0] -= offset
        break
      case direction.E:
        to[0] += tileSize / 2
        to[1] -= offset
        break
    }

    const fromPt = new THREE.Vector3(start[0], 0, start[1])
    const toPt = new THREE.Vector3(to[0], 0, to[1])
    const centerPt = new THREE.Vector3(fromPosition[0], 0, fromPosition[1])


    if (tileType.directionChange === 0) {
      const curve = new THREE.LineCurve3(fromPt, toPt)
      path.add(curve)
    } else {
      const curve = new THREE.QuadraticBezierCurve3(fromPt, centerPt, toPt)
      path.add(curve)
    }
  }

  return path
}

// export let path = getPath(tileTypes, tileSize, direction, layout, gameConfig, 1.0)
export let path = getPath(0)
export default path


// // testing
// console.log(path.curves[9].v1.x)
// let path2 = getPath(tileTypes, tileSize, direction, layout, gameConfig, 1.2)
// console.log(path2.curves[9].v1.x)

// **************************************************
//
// POINTS
//
// **************************************************
export let points = []
points = normalize(points)




// WEBPACK FOOTER //
// ./src/components/game/track-tiled/path.js